import { Chip, Tooltip } from '@mui/material';
import { severityColor, triageColor, type ClinicalSeverity, type TriageLevel } from '@/theme/theme';

export function SeverityChip({
  severity,
  label,
  small = false,
}: { severity: ClinicalSeverity; label?: string; small?: boolean }) {
  const text = label ?? severity;
  const bg = severityColor(severity);
  return (
    <Chip
      size={small ? 'small' : 'medium'}
      label={text}
      sx={{
        bgcolor: bg,
        color: '#fff',
        fontWeight: 600,
        textTransform: 'capitalize',
      }}
    />
  );
}

export function TriageBadge({
  level,
  small = false,
}: { level: TriageLevel; small?: boolean }) {
  const tooltips: Record<TriageLevel, string> = {
    routine:   'Routine — schedule normally.',
    soon:      'Soon — within days.',
    urgent:    'Urgent — same-day care recommended.',
    emergency: 'Emergency — call your local emergency number now.',
  };
  return (
    <Tooltip title={tooltips[level]}>
      <Chip
        size={small ? 'small' : 'medium'}
        label={level}
        sx={{
          bgcolor: triageColor(level),
          color: '#fff',
          fontWeight: 600,
          textTransform: 'capitalize',
        }}
      />
    </Tooltip>
  );
}
